import {FieldsConfiguration, FieldsForm} from '../../../fields/types'

import {buildConfirmationPinForm} from './confirmationPin/buildConfirmationPinForm'
import {buildDateTimeForm} from './dateTime/buildDateTimeForm'
import {buildIsConfirmedForm} from './isConfirmed/buildIsConfirmedForm'
import {buildLoadBalanceForm} from './loadBalance/buildLoadBalanceForm'
import {buildLoadSpacingForm} from './loadSpacing/buildLoadSpacingForm'
import {buildMixForm} from './mix/buildMixForm'
import {buildOrderPlacerForm} from './orderPlacer/buildOrderPlacerForm'
import {buildPlusLoadForm} from './plusLoad/buildPlusLoadForm'
import {buildPoNumberForm} from './poNumber/buildPoNumberForm'
import {buildQuantityForm} from './quantity/buildQuantityForm'
import {buildSiteContactForm} from './siteContact/buildSiteContactForm'
import {buildIsTestBookedForm} from './testing/buildIsTestBookedForm'
import {buildAdditionalNotesForm} from './textField/buildTextFieldForm'
import {buildTruckForm} from './trucks/buildTruckForm'
import {CreateFormInput} from './types'

export const buildForm = (input: CreateFormInput<FieldsConfiguration>): FieldsForm => {
  return {
    ...buildTruckForm(input),
    ...buildLoadSpacingForm(input),
    ...buildQuantityForm(input),
    ...buildPlusLoadForm(input),
    ...buildLoadBalanceForm(input),
    ...buildIsConfirmedForm(input),
    ...buildConfirmationPinForm(),
    ...buildMixForm(input),
    ...buildDateTimeForm(input),
    ...buildSiteContactForm(input),
    ...buildOrderPlacerForm(input),
    ...buildAdditionalNotesForm(),
    ...buildIsTestBookedForm(input),
    ...buildPoNumberForm(input)
  }
}
